/**
 * The order actions appear in the Command menu.
 *
 * Separate from the `ACTIONS` table because the table's key order is alphabetical-ish by
 * authoring convenience, whereas the menu wants *frequency* order: the things you do
 * every turn at the top, the once-a-game things at the bottom, Pass last so nobody hits
 * it by accident when mashing A.
 */

import type { ActionKind } from '../game/types';

export const ACTION_ORDER: readonly ActionKind[] = [
  'claim',
  'upgrade',
  'move',
  'survey',
  'research',
  'deployFleet',
  'terraform',
  'trade',
  'megastructure',
  'pass',
];
